const s = {
  name: "VirtualCard",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v3h2V5c0-1.7,1.3-3,3-3V0z"/>
		<path class="st0" d="M0,14v7c0,2.8,2.2,5,5,5h8v-2H5c-1.7,0-3-1.3-3-3v-7H0z"/>
		<path class="st0" d="M38,21v-3h2v3c0,2.8-2.2,5-5,5h-4v-2h4C36.7,24,38,22.7,38,21z"/>
		<path class="st0" d="M35,2c1.7,0,3,1.3,3,3H26v2h12v5h2V5c0-2.8-2.2-5-5-5V2z"/>
		<path class="st0" d="M11,2h18V0H11V2z"/>
		<path class="st0" d="M20,7H8V5h12V7z"/>
		<path class="st0" d="M22,7h2V5h-2V7z"/>
		<path class="st0" d="M28,12h-2v-2h2V12z"/>
		<path class="st0" d="M19,24v2h2v-2H19z"/>
		<path class="st0" d="M17,26h-2v-2h2V26z"/>
		<path class="st0" d="M38,16h2v-2h-2V16z"/>
		<path class="st0" d="M33,2h-2V0h2V2z"/>
		<path class="st0" d="M7,2h2V0H7V2z"/>
		<path class="st0" d="M2,12H0v-2h2V12z"/>
		<path class="st0" d="M4,5v2h2V5H4z"/>
		<path class="st0" d="M24,12H4v-2h20V12z"/>
		<path class="st0" d="M30,10v2h6v-2H30z"/>
		<path class="st0" d="M23,26v-2h6v2H23z"/>
		<path class="st0" d="M5,21h12v-2H5V21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as VirtualCard
};
